const RECIPIENT_CC_LABEL_MAPPINGS = {
  LaborBCSubstantiation: {
    'SME (Primary assignee)': 'Substantiation Primary Owner',
    'Secondary assignee': 'Partner',
    'Direct manager': 'Substantiation Primary Owner Manager',
  },
  LaborProjectSubstantiation: {
    'SME (Primary assignee)': 'Substantiation Provider',
    'Secondary assignee': 'Partner',
    'Direct manager': 'Substantiation Provider Manager',
  },
};

const EVENT_LABEL_MAPPINGS = {
  LaborBCSubstantiation: {
    'Upon secondary assignee selection': 'Upon partner assignment',
  },
  LaborProjectSubstantiation: {
    'Upon secondary assignee selection': 'Upon partner assignment',
  },
};

const getOptionsDefinition = (options, surveyType, mappingType = 'recipient') => {
  const labelMap =
    mappingType === 'event'
      ? EVENT_LABEL_MAPPINGS[surveyType] || {}
      : RECIPIENT_CC_LABEL_MAPPINGS[surveyType] || {};
  const updatedOptions = [];
  // eslint-disable-next-line no-restricted-syntax
  for (const option of options) {
    const { label, value } = option;
    updatedOptions.push({ label: labelMap[label] || label, value });
  }
  return updatedOptions;
};

export default getOptionsDefinition;
